// hooks/useIdleTimeout.js
import { useEffect, useRef, useCallback } from 'react';

const IDLE_TIMEOUT_MS = 20 * 60 * 1000; // 20 minuter
const WARNING_BEFORE_MS = 2 * 60 * 1000; // Varna 2 min innan

export const useIdleTimeout = ({ onLogout, onWarning, onActive, enabled = true }) => {
  const timeoutRef = useRef(null);
  const warningRef = useRef(null);
  const isWarningShownRef = useRef(false);

  const resetTimer = useCallback(() => {
    clearTimeout(timeoutRef.current);
    clearTimeout(warningRef.current);

    // Om varning visades → meddela att användaren är aktiv igen
    if (isWarningShownRef.current) {
      isWarningShownRef.current = false;
      onActive?.();
    }

    // Sätt varning 2 min innan logout
    warningRef.current = setTimeout(() => {
      isWarningShownRef.current = true;
      onWarning?.();
    }, IDLE_TIMEOUT_MS - WARNING_BEFORE_MS);

    // Sätt logout-timer
    timeoutRef.current = setTimeout(() => {
      onLogout();
    }, IDLE_TIMEOUT_MS);
  }, [onLogout, onWarning, onActive]);

  useEffect(() => {
    if (!enabled) return;  // ✅ Gör ingenting om inaktiverad
    // Händelser som räknas som aktivitet
    const events = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll', 'click'];

    // Throttle: reagera max var 10:e sekund för att undvika perf-problem
    let lastReset = 0;
    const handleActivity = () => {
      const now = Date.now();
      if (now - lastReset > 10_000) {
        lastReset = now;
        resetTimer();
      }
    };

    events.forEach(e => window.addEventListener(e, handleActivity, { passive: true }));
    resetTimer(); // Starta timern direkt vid mount

    return () => {
      events.forEach(e => window.removeEventListener(e, handleActivity));
      clearTimeout(timeoutRef.current);
      clearTimeout(warningRef.current);
    };
  }, [resetTimer, enabled]);
};